import { UPDATE_USER_UID} from "./userUidReducer"

export const updateUserUid = (obj) => ({
    type: UPDATE_USER_UID,
    payload: obj
})